import api from "./axios";

class ServiceMachine {
  async createOrder(idSale, typeIntegration = 'stone', saleType ) {
    const { data } = await api.get(`/machine/${idSale}?type=${typeIntegration}&saleType=${saleType}`);

    return data;
  }

  async cancelOrder(idSale, typeIntegration = 'stone', saleType) {
    const { data } = await api.get(`/machine/cancel-order/${idSale}?type=${typeIntegration}&saleType=${saleType}`);

    return data;
  }

  async checkIsPaidAndGenerateDocument(idSale, typeIntegration = 'stone', saleType) {
    const { data } = await api.get(`/machine/check-is-paid/generate-document/${idSale}?type=${typeIntegration}&saleType=${saleType}`);

    return data;
  }

  async checkIsPaidAndGenerateDocumentNfe(idSale, typeIntegration = 'stone', saleType) {
    const { data } = await api.get(`/machine/check-is-paid/generate-document/nfe/${idSale}?type=${typeIntegration}&saleType=${saleType}`);

    return data;
  }

  async checkOrder(idSale, type) {
    const { data } = await api.get(`/machine/check-order/${idSale}?type=${type}`);
    
    return data;
  }

  async printDocument(idSale, base64Document, typeIntegration = 'stone', saleType) {
    await api.post(`/machine/print/${idSale}?type=${typeIntegration}&saleType=${saleType}`, { base64Document })
  }
}

export default new ServiceMachine()